import { z } from 'zod';
/**
 * Notifications: in-app always; email through an adapter (synthetic in
 * dev/test — no production mail credentials exist in this repo). Bodies
 * carry SAFE METADATA ONLY: names, identifiers and link paths — never note
 * bodies, case descriptions, attachments or any payload content.
 */
export const NOTIFICATION_KINDS = [
    'approval.submitted',
    'approval.decided',
    'approval.executed',
    'case.assigned',
    'case.sla_breached',
    'task.assigned',
    'onboarding.step_blocked',
];
export const NotificationKindSchema = z.enum(NOTIFICATION_KINDS);
export const NOTIFICATION_CHANNELS = ['in_app', 'email'];
export const DELIVERY_STATUSES = ['pending', 'delivered', 'failed', 'dead'];
export const NotificationSchema = z.object({
    id: z.uuid(),
    kind: NotificationKindSchema,
    subject: z.string(),
    body: z.string(),
    linkPath: z.string().nullable(),
    createdAt: z.iso.datetime(),
    readAt: z.iso.datetime().nullable(),
});
export const NotificationPrefSchema = z
    .object({
    kind: NotificationKindSchema,
    inApp: z.boolean(),
    email: z.boolean(),
})
    .strict();
export const NotificationPrefsUpdateSchema = z
    .object({ prefs: z.array(NotificationPrefSchema).max(20) })
    .strict();
//# sourceMappingURL=notifications.js.map